import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Feature group messages
  orderManagement: {
    defaultMessage: 'Order Management',
    description: 'Order Management feature group for subscription plans',
    id: '23SyKQ',
  },
  shipping: {
    defaultMessage: 'Shipping',
    description: 'Shipping feature group for subscription plans',
    id: 'fOGFIB',
  },
  returns: {
    defaultMessage: 'Returns',
    description: 'Returns feature group for subscription plans',
    id: 'I5FxfI',
  },
  tracking: {
    defaultMessage: 'Tracking',
    description: 'Tracking feature group for subscription plans',
    id: '0HWxrF',
  },
  automation: {
    defaultMessage: 'Automation',
    description: 'Automation feature group for subscription plans',
    id: 'H0vkmn',
  },
  scale: {
    defaultMessage: 'Scale',
    description: 'Scale feature group for subscription plans',
    id: 'E7rChP',
  },
  dataAndReporting: {
    defaultMessage: 'Data and Reporting',
    description: 'Data and Reporting feature group for subscription plans',
    id: 'xbodOo',
  },
  inventory: {
    defaultMessage: 'Inventory',
    description: 'Inventory feature group for subscription plans',
    id: '6mBLhC',
  },
  warehouseManagement: {
    defaultMessage: 'Warehouse Management',
    description: 'Warehouse Management feature group for subscription plans',
    id: 'kAk58f',
  },
  support: {
    defaultMessage: 'Support',
    description: 'Support feature group for subscription plans',
    id: 'TjvQuQ',
  },
  otherIntegrationsCategory: {
    defaultMessage: 'Other Integrations',
    description: 'Other Integrations feature group for subscription plans',
    id: '4/aHrl',
  },

  // Feature messages - Order Management
  manualOrderCreation: {
    defaultMessage: 'Manual Order Creation',
    description: 'Manual Order Creation feature',
    id: 'WrDJdk',
  },
  orderImportCSV: {
    defaultMessage: 'Order Import (CSV + Store Integrations)',
    description: 'Order Import (CSV + Store Integrations) feature',
    id: '4paGdl',
  },
  orderImportCustom: {
    defaultMessage: 'Order Import (Custom Store)',
    description: 'Order Import (Custom Store) feature',
    id: 'wrH/dO',
  },
  combineSplitOrders: {
    defaultMessage: 'Combine and split orders & shipments',
    description: 'Combine and split orders & shipments feature',
    id: 'u/X/VU',
  },

  // Feature messages - Shipping
  addressValidation: {
    defaultMessage: 'Address validation',
    description: 'Address validation feature',
    id: '0t4OcG',
  },
  discountedCarrierRates: {
    defaultMessage: 'Discounted carrier rates',
    description: 'Discounted carrier rates feature',
    id: 'Ib0qbi',
  },
  insurancePurchase: {
    defaultMessage: 'Insurance for purchase',
    description: 'Insurance for purchase feature',
    id: '7zcbmc',
  },
  byoa: {
    defaultMessage: 'Bring your own carrier accounts',
    description: 'BYOA (Bring Your Own Account) feature',
    id: 'WeMjD4',
  },

  // Feature messages - Returns
  standardLegacyReturnsPortal: {
    defaultMessage: 'Standard Legacy Returns Portal',
    description: 'Standard Legacy Returns Portal feature',
    id: 'BoqAFG',
  },
  manualReturnLabels: {
    defaultMessage: 'Manual Return Labels',
    description: 'Manual Return Labels feature',
    id: '0qw7ZZ',
  },
  merchantManagedReturnsPortal: {
    defaultMessage: 'Merchant Managed Returns Portal',
    description: 'Merchant Managed Returns Portal feature',
    id: 'piEjoQ',
  },
  brandedReturnsExchangePortal: {
    defaultMessage: 'Branded Returns Exchange Portal',
    description: 'Branded Returns Exchange Portal feature',
    id: 'AK/Bm9',
  },

  // Feature messages - Tracking
  customerNotificationEmails: {
    defaultMessage: 'Customer notification emails',
    description: 'Customer notification emails feature',
    id: 'AQNuc2',
  },
  brandedNotificationEmails: {
    defaultMessage: 'Branded Notification emails',
    description: 'Branded Notification emails feature',
    id: 'Tl5Cfe',
  },
  brandedTracking: {
    defaultMessage: 'Branded tracking',
    description: 'Branded tracking feature',
    id: 'O8Uxar',
  },

  // Feature messages - Automation
  labelGenAutomationRules: {
    defaultMessage: 'Label Gen automation rules',
    description: 'Automation rules for shipping label generation feature',
    id: '02GsIQ',
  },
  unlimitedAutomationRules: {
    defaultMessage: 'Unlimited automation rules types',
    description: 'Unlimited automation rules types feature',
    id: 'VujrSv',
  },
  automatedRateShopper: {
    defaultMessage: 'Automated Rate Shopper',
    description: 'Automated Rate Shopper feature',
    id: 'nhqtBu',
  },
  customizedRateShopper: {
    defaultMessage: 'Customized Rate Shopper',
    description: 'Customized Rate Shopper feature',
    id: 'Ie5CnL',
  },
  autoSplit: {
    defaultMessage: 'Auto-Split',
    description: 'Auto-Split feature',
    id: 'B62xmJ',
  },
  cubiscan: {
    defaultMessage: 'Cubiscan',
    description: 'Cubiscan feature',
    id: 'CXqImQ',
  },

  // Feature messages - Scale
  purchaseAdditionalUsers: {
    defaultMessage: 'Purchase Additional Users',
    description: 'Purchase Additional Users feature',
    id: 'Gog91d',
  },
  userPermissions: {
    defaultMessage: 'User Permissions',
    description: 'User Permissions feature',
    id: 'D1Fe8s',
  },
  googleSSO: {
    defaultMessage: 'Google SSO',
    description: 'Google SSO feature',
    id: '7F7jaJ',
  },
  apiAccess: {
    defaultMessage: 'API Access (including Inventory)',
    description: 'API Access (including Inventory) feature',
    id: 'u0zR8w',
  },

  // Feature messages - Data and Reporting
  dataExport: {
    defaultMessage: 'Data export',
    description: 'Data export feature',
    id: 'eUDiIp',
  },
  reportsViewOnly: {
    defaultMessage: 'Reports (View only)',
    description: 'Reports (View only) feature',
    id: 'LAysoY',
  },
  reportsDownload: {
    defaultMessage: 'Reports (Download)',
    description: 'Reports (Download) feature',
    id: 'BRSM+V',
  },
  dashboardsViewOnly: {
    defaultMessage: 'Dashboards (View Only)',
    description: 'Dashboards (View Only) feature',
    id: 'ZHVNNC',
  },
  odbc: {
    defaultMessage: 'ODBC',
    description: 'ODBC feature',
    id: 'G36MyA',
  },

  // Feature messages - Inventory
  productCatalog: {
    defaultMessage: 'Product Catalog',
    description: 'Product Catalog feature',
    id: '8qvPDo',
  },
  inventoryGrid: {
    defaultMessage: 'Inventory Grid (CSV Uploads for Tracking)',
    description: 'Inventory Grid (CSV Uploads for Tracking) feature',
    id: 'wDCRtV',
  },
  bundles: {
    defaultMessage: 'Bundles',
    description: 'Bundles feature',
    id: 'OcSLFQ',
  },
  lotTracking: {
    defaultMessage: 'Lot Tracking',
    description: 'Lot Tracking feature',
    id: '14B4HX',
  },
  inventoryTrackingSync: {
    defaultMessage: 'Inventory Tracking & Sync',
    description: 'Inventory Tracking & Sync feature',
    id: 'Y3ANBC',
  },
  reorderAssist: {
    defaultMessage: 'Reorder Assist (forecasting)',
    description: 'Reorder Assist (forecasting) feature',
    id: 'pr7Dgr',
  },
  purchaseOrders: {
    defaultMessage: 'Purchase Orders',
    description: 'Purchase Orders feature',
    id: 'ezNQHy',
  },
  scanToReceive: {
    defaultMessage: 'Scan to Receive',
    description: 'Scan to Receive feature',
    id: '0b5hHg',
  },

  // Feature messages - Warehouse Management
  packingSlips: {
    defaultMessage: 'Packing Slips',
    description: 'Packing Slips feature',
    id: '7My+Hp',
  },
  packingSlipsCustomized: {
    defaultMessage: 'Packing Slips (Customized)',
    description: 'Packing Slips (Customized) feature',
    id: 'ClIxUF',
  },
  barcodeScanning: {
    defaultMessage: 'Barcode Scanning',
    description: 'Barcode Scanning feature',
    id: 'JK/RNe',
  },
  hotKeys: {
    defaultMessage: 'Hot Keys: Barcode actions & Custom Hot Keys',
    description: 'Hot Keys: Barcode actions & Custom Hot Keys feature',
    id: 'gI5b8W',
  },
  pickLists: {
    defaultMessage: 'Pick Lists',
    description: 'Pick Lists feature',
    id: '9stG9g',
  },
  mobilePicking: {
    defaultMessage: 'Mobile Picking',
    description: 'Mobile Picking feature',
    id: 'Us4Tmx',
  },
  pickingStatuses: {
    defaultMessage: 'Picking Statuses',
    description: 'Picking Statuses feature',
    id: 'GtfAmI',
  },
  pickToTote: {
    defaultMessage: 'Pick to Tote',
    description: 'Pick to Tote feature',
    id: '6t93G6',
  },

  // Feature messages - Support
  chatbotForumHelpLibrary: {
    defaultMessage: 'Chatbot / Community Forum / Help Library',
    description: 'Email / Community Forum / Help Library feature',
    id: 'et3gHd',
  },
  emailSupport: {
    defaultMessage: 'Email',
    description: 'Email support feature',
    id: '+nYHWh',
  },
  chatSupport: {
    defaultMessage: 'Chat',
    description: 'Chat support feature',
    id: 'AC/eWl',
  },
  phoneSupport: {
    defaultMessage: 'Phone Support',
    description: 'Phone Support feature',
    id: 'Ra8Lhh',
  },
  dedicatedAccountManagement: {
    defaultMessage: 'Dedicated Account Management',
    description: 'Dedicated Account Management',
    id: 'fhQGoU',
  },

  // Feature messages - Other Integrations
  quickBooksIntegration: {
    defaultMessage: 'QuickBooks integration',
    description: 'QuickBooks integration feature',
    id: 'JB0rHK',
  },
  webhooksIntegration: {
    defaultMessage: 'Webhooks',
    description: 'Webhooks integration feature',
    id: 'ny7AES',
  },
  returnRabbit: {
    defaultMessage: 'Return Rabbit',
    description: 'Return Rabbit integration feature',
    id: 'Ua4p63',
  },
  googleIntegration: {
    defaultMessage: 'Google',
    description: 'Google integration feature',
    id: 'yoaKqI',
  },
  mailchimpIntegration: {
    defaultMessage: 'MailChimp',
    description: 'MailChimp integration feature',
    id: 'IHDMA7',
  },
  zapierIntegration: {
    defaultMessage: 'Zapier',
    description: 'Zapier integration feature',
    id: 'aN0Xpa',
  },
  otherIntegrationsFeature: {
    defaultMessage: 'Others',
    description: 'Other integrations feature',
    id: 'Y0kArM',
  },
});
